import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M1 3a3 3 0 0 1 3-3h26a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V3Z"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#98A2B3",
  d: "M5 13.5v4.286h20V13.5H5Zm11.429 1.429h1.428v1.428H16.43V14.93Zm2.857 0h1.428v1.428h-1.428V14.93Zm2.857 0h1.428v1.428h-1.428V14.93Z"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#98A2B3",
  d: "M3.429 0A2.431 2.431 0 0 0 1 2.433v19.134A2.431 2.431 0 0 0 3.429 24H30.57A2.431 2.431 0 0 0 33 21.567V2.433A2.431 2.431 0 0 0 30.571 0H3.43Zm0 1.217H30.57c.671 0 1.215.544 1.215 1.216V3.65H2.214V2.433c0-.672.544-1.216 1.215-1.216Zm-1.215 9.519h29.572v10.83c0 .673-.544 1.217-1.215 1.217H3.43c-.671 0-1.215-.544-1.215-1.216V10.736Z"
}, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }